import { find } from "utils/dom"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	console.log('Page home');
	window.addEventListener('scroll', function () {
  const header = document.querySelector('.header');
  if (window.scrollY > 50) {
    header.classList.add('shrink');
  } else {
    header.classList.remove('shrink');
  }
});


 const tl = gsap.timeline();

    // Etapa 1: Mostrar todas ao mesmo tempo (fade-in)
    tl.to(".image", {
      opacity: 1,
      duration: 1,
      ease: "power2.out"
    });

    // Etapa 2: Mover cada imagem para posições diferentes
    tl.to(".image1", {
      top: "0%",
      left: "0%",
      duration: 1
    }, ">");

    tl.to(".image2", {
      top: "0%",
      left: "0%",
      duration: 1
    }, "<"); // Começa junto com a anterior

    tl.to(".image3", {
      top: "0%",
      left: "0%",
      duration: 1
    }, "<"); // Também junto


		 const tl2 = gsap.timeline();

    
     tl2.to(".image-base", {
				opacity: 1,
				width:"85.5%",
				duration: 1,
				ease: "power2.out"
     });

		 // Etapa 2: Mover cada imagem para posições diferentes
    tl2.to(".image-efeito", {
				opacity: 1,
				left:0,
				duration: 1,
				ease: "power2.out"
    }, ">");

		tl2.to(".image-base-2", {
				opacity: 1,
				duration: 1,
				ease: "power2.out"
		});

		tl2.to(".image-efeito-mobile", {
  	  	opacity: 1,
				top:"0%",
  	   	duration: 1,
		 		ease: "power2.out"
  	}, ">");


		const museuVirtualOpen = () =>{
				const btnMuseus = document.querySelectorAll('.btn-museu-virtual')
				const iframeMuseu = document.getElementById('museu-virtual')
				const bodySite = document.getElementById('body-site')

				btnMuseus.forEach(btnMuseu=>{
						btnMuseu.addEventListener('click', (e)=>{
								if (btnMuseu.innerText === 'MUSEU VIRTUAL' || btnMuseu.innerText === 'CLIQUE E DESCUBRA' ){
										btnMuseus.forEach(btnMuseu=>{btnMuseu.innerText = 'VER SITE'})
										iframeMuseu.classList.add('active')
										bodySite.classList.add('disable')
								}
								else{
									btnMuseus.forEach(btnMuseu=>{btnMuseu.innerText = 'MUSEU VIRTUAL'})
									const museu = document.querySelector('.click-descubra')
									museu.innerText = 'CLIQUE E DESCUBRA'
									iframeMuseu.classList.remove('active')
									bodySite.classList.remove('disable')
								} 
						})
				})
				
		}

		museuVirtualOpen()
}